import React from 'react';
import { Link } from 'gatsby';
import cn from 'classnames';

import { zeroPad } from '../util/functions';

import Wrapper from './Wrapper';

import * as styles from './IssueTeaser.module.css';

const IssueTeaser = ({ issue, onClick }) => {
  return (
    <Link
      to={`/${issue.slug}`}
      onClick={onClick}
      style={{ background: issue.colors.pageBackground }}
      className={cn(styles.root)}
    >
      <Wrapper className={cn(styles.wrapper)}>
        <div className={cn(styles.titleGroup)}>
          <span className={cn(styles.number)}>
            ({zeroPad(issue.number, 2)})
          </span>
          <h2 className={cn(styles.title)}>{issue.title}</h2>
        </div>
        <div className={cn(styles.intro)}>{issue.intro.headline}</div>
      </Wrapper>
    </Link>
  );
};

export default IssueTeaser;
